// A swappable source of randomness.
//
// Free play wants a different board every time, so the generators call
// `random()` and get `Math.random` by default. Progression levels have to come
// out identical on every device, so level setup runs inside `withSeed`, which
// points that same call at a deterministic stream for the duration.

/** Mulberry32 — small, fast, and good enough for board layout. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6D2B79F5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

let current: () => number = Math.random;

export function random(): number {
  return current();
}

/** Run `fn` with every `random()` call drawn from a stream fixed by `seed`. */
export function withSeed<T>(seed: number, fn: () => T): T {
  const prev = current;
  current = mulberry32(seed);
  try {
    return fn();
  } finally {
    current = prev;
  }
}
